"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[7369],{

/***/ 82802:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90234);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78565);




const styles = (/* unused pure expression or super */ null && ([
    "error"
]));
const ICONS = {
    error: "24/info"
};
const STYLES = {
    error: "bg-light-red text-red"
};
const Alert = (props)=>{
    const { "data-testid": dataTestId, className, message, messageStyle = "p4", style } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "flex items-center rounded px-8 py-16", STYLES[style]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                className: "min-w-24 min-h-24",
                name: ICONS[style]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "ml-12",
                message: message,
                style: messageStyle,
                html: true,
                "data-testid": dataTestId
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Alert));


/***/ }),

/***/ 23541:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ErrorBlock_ErrorBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/feedback/ErrorBlock/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Something went wrong"
    },
    text: {
        en: `
      We\`re having technical issues at that moment. Please try again later or contact our customer support
      at <a href="mailto:support@scentbird.com">support@scentbird.com</a>
    `
    }
});

;// CONCATENATED MODULE: ./src/components/feedback/ErrorBlock/ErrorBlock.tsx





const ErrorBlock = (props)=>{
    const { title = messages.title, text = messages.text } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-464",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: isMobile ? "h4" : "h2",
                tag: "h2",
                message: title,
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: isMobile ? "mt-16" : "mt-24",
                style: isMobile ? "p2" : "p1",
                tag: "p",
                message: text,
                html: true
            })
        ]
    });
};
/* harmony default export */ const ErrorBlock_ErrorBlock = (ErrorBlock);


/***/ }),

/***/ 21316:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39977);
/* harmony import */ var components_feedback__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14931);





const Explanation = (props)=>{
    const { children, title, text, "data-testid": dataTestId, onShow } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (isMobile) {
            (0,modals__WEBPACK_IMPORTED_MODULE_3__/* .openModal */ .h7)("commonDrawerModal", {
                title,
                text,
                "data-testid": "explanation"
            });
        }
        if (typeof onShow === "function") {
            onShow();
        }
    }, [
        isMobile,
        title,
        text,
        onShow
    ]);
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            onClick: handleClick,
            "data-testid": dataTestId,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_feedback__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: title,
        text: text,
        style: "light-beige",
        onShow: onShow,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "cursor-help",
            "data-testid": dataTestId,
            children: children
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Explanation);


/***/ }),

/***/ 32646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Modal_Modal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(1987);
// EXTERNAL MODULE: ./src/components/feedback/ModalHeadline/ModalHeadline.tsx
var ModalHeadline = __webpack_require__(52690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/feedback/ModalBasementNote/ModalBasementNote.tsx




const ModalBasementNote = (param)=>{
    let { className, message } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)(className, "text-center"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            tag: "span",
            style: "p4",
            message: message,
            html: true
        })
    });
};
/* harmony default export */ const ModalBasementNote_ModalBasementNote = (/*#__PURE__*/react.memo(ModalBasementNote));

// EXTERNAL MODULE: ./src/components/feedback/ModalButtons/ModalButtons.tsx
var ModalButtons = __webpack_require__(99032);
;// CONCATENATED MODULE: ./src/components/feedback/Modal/Modal.tsx




const Modal = (props)=>{
    const { children, className, overlayClassName, title, titleStyle, text, basementNote, buttonsClassName, primaryButton, secondaryButton, tertiaryButton, overlayClosable, type, bgColor, closeButtonIcon, withCloseButton, closeModal, withMargin, "data-testid": dataTestId } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const areButtonsVisible = Boolean(primaryButton || secondaryButton || tertiaryButton);
    const isBasementNoteVisible = Boolean(basementNote);
    const isBasementVisible = areButtonsVisible || isBasementNoteVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlainModal/* default */.ZP, {
        className: className,
        overlayClassName: overlayClassName,
        type: type,
        overlayClosable: overlayClosable,
        bgColor: bgColor,
        closeButtonIcon: closeButtonIcon,
        withCloseButton: withCloseButton,
        closeModal: closeModal,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeadline/* default */.Z, {
                title: title,
                titleStyle: titleStyle,
                text: text,
                withMargin: withMargin
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-1 flex-col items-stretch justify-start",
                children: children
            }),
            isBasementVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: isMobile ? "mt-32" : "mt-40",
                children: [
                    isMobile && isBasementNoteVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBasementNote_ModalBasementNote, {
                        className: "mb-16",
                        message: basementNote
                    }),
                    areButtonsVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButtons/* default */.Z, {
                        className: buttonsClassName,
                        primary: primaryButton,
                        secondary: secondaryButton,
                        tertiary: tertiaryButton,
                        withMargin: false
                    }),
                    !isMobile && isBasementNoteVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBasementNote_ModalBasementNote, {
                        className: "mt-24",
                        message: basementNote
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const Modal_Modal = (Modal);


/***/ }),

/***/ 99032:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30468);





const ModalButtons = (props)=>{
    const { children, className, primary, secondary, tertiary, withMargin = true } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const marginClassName = isMobile ? "mt-32" : "mt-40";
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, "grid gap-16", isMobile ? "justify-items-stretch" : "justify-items-center", {
        [marginClassName]: withMargin
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: rootClassName,
        children: [
            children,
            primary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                ...primary,
                style: primary.style || "primary",
                size: 56,
                width: 280,
                "data-testid": "modalPrimaryButton"
            }),
            secondary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                ...secondary,
                style: secondary.style || "secondary",
                size: 56,
                width: 280,
                "data-testid": "modalSecondaryButton"
            }),
            tertiary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                ...tertiary,
                style: tertiary.style || "tertiary",
                size: 56,
                "data-testid": "modalTertiaryButton"
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalButtons);


/***/ }),

/***/ 52690:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96934);
/* harmony import */ var components_feedback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1987);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78565);





const ModalHeadline = (props)=>{
    const { title, step, text, withMargin = true, titleStyle = "sh3" } = props;
    const { titleId, textId } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(components_feedback__WEBPACK_IMPORTED_MODULE_2__/* .ModalContext */ .tC);
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: withMargin ? "mb-32" : undefined,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: isMobile ? "pr-48" : "pr-32",
                id: titleId,
                message: title,
                style: titleStyle,
                html: true,
                "data-testid": "title"
            }),
            Boolean(step) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: isMobile ? "mt-24" : "mt-16",
                message: step,
                style: "eye2",
                color: "gold-50",
                html: true,
                "data-testid": "stepText"
            }),
            Boolean(text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: isMobile ? "mt-24" : "mt-16",
                id: textId,
                message: text,
                style: "p2",
                html: true,
                "data-testid": "text"
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ModalHeadline));


/***/ }),

/***/ 94013:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);




const ModalHero = (param)=>{
    let { children, className, withMargin = true } = param;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(isMobile ? "-mx-16 -mt-40" : "-mx-40 -mt-48", withMargin && "mb-32", className),
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ModalHero));


/***/ }),

/***/ 14546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ModalWithLayers_ModalWithLayers),
  y: () => (/* binding */ useModalWithLayers)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(1987);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/trap-focus/TrapFocus.ts
var TrapFocus = __webpack_require__(66149);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
;// CONCATENATED MODULE: ./src/components/feedback/ModalWithLayers/util/index.ts

const ModalWithLayersContext = (0,react.createContext)(null);

;// CONCATENATED MODULE: ./src/components/feedback/ModalWithLayers/components/Layer/Layer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Layer_module = ({"layer":"XwStxi","openLayer":"P8BuJj","close":"cEZMcq","closeLayer":"e2XeIu"});
;// CONCATENATED MODULE: ./src/components/feedback/ModalWithLayers/components/Layer/Layer.tsx











const ANIMATION_DURATION = 300;
const Layer = (props)=>{
    const { children, id, bgColor = "gray-10", backButtonStyle = "black-icon", pxMobile = 16, scrollIntoView = false } = props;
    const { activeLayers, closeLayer } = (0,react.useContext)(ModalWithLayersContext);
    const { isMobile } = (0,useDevice/* default */.Z)();
    const intl = (0,useIntl/* default */.Z)();
    const layerRef = (0,react.useRef)(null);
    const timeoutRef = (0,react.useRef)(null);
    const isVisible = activeLayers.has(id);
    const backButtonLabel = intl.formatMessage(messages/* default */.Z.back);
    const handleCloseLayer = (0,react.useCallback)(()=>{
        layerRef.current.classList.add(Layer_module.close);
        timeoutRef.current = setTimeout(()=>{
            closeLayer(id);
        }, ANIMATION_DURATION);
    }, [
        id,
        closeLayer
    ]);
    (0,react.useEffect)(()=>{
        const trapFocusElement = layerRef.current;
        if (isVisible && layerRef.current) {
            const trapFocus = new TrapFocus/* default */.Z(trapFocusElement, {
                withInitialFocus: false
            });
            trapFocusElement.focus();
            trapFocus.mount();
            let timeoutId;
            if (scrollIntoView) {
                // avoid flashing because of drawer animation
                timeoutId = setTimeout(()=>{
                    layerRef.current.scrollIntoView({
                        behavior: "smooth"
                    });
                }, ANIMATION_DURATION);
            }
            return ()=>{
                clearTimeout(timeoutId);
                trapFocus.unmount();
            };
        }
    }, [
        isVisible
    ]);
    if (!isVisible) {
        return null;
    }
    const isActionButton = backButtonStyle === "action-button";
    const iconName = isActionButton ? "other/long-arrow-left" : "32/arrow-left";
    const contentClassName = (0,clsx/* default */.Z)("h-full w-full pb-16 pt-80", isMobile && pxMobile === 16 ? "px-16" : "px-40");
    const backButtonOffsetClasses = pxMobile === 16 ? "m-16" : "mt-32 ml-40";
    const backButtonClassName = (0,clsx/* default */.Z)("absolute left-0 top-0 cursor-pointer", isMobile ? backButtonOffsetClasses : "m-32", isActionButton && "py-8 text-gold-50");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: layerRef,
        className: (0,clsx/* default */.Z)(Layer_module.layer, "absolute left-0 top-0 h-full w-full", PlainModal/* bgColorToClassName */.LO[bgColor]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: contentClassName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: backButtonClassName,
                    type: "button",
                    "aria-label": backButtonLabel,
                    onClick: handleCloseLayer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: iconName
                            }),
                            isActionButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-12 text-t5",
                                children: backButtonLabel
                            })
                        ]
                    })
                }),
                children
            ]
        })
    });
};
/* harmony default export */ const Layer_Layer = (Layer);

;// CONCATENATED MODULE: ./src/components/feedback/ModalWithLayers/components/OpenButton/OpenButton.tsx


const OpenButton = (param)=>{
    let { children, layerId } = param;
    const { openLayer } = (0,react.useContext)(ModalWithLayersContext);
    return /*#__PURE__*/ react.cloneElement(children, {
        onClick: (event)=>{
            openLayer(layerId);
            if (typeof children.props.onClick === "function") {
                children.props.onClick(event);
            }
        }
    });
};
/* harmony default export */ const OpenButton_OpenButton = (OpenButton);

;// CONCATENATED MODULE: ./src/components/feedback/ModalWithLayers/ModalWithLayers.tsx






const ModalWithLayers = (props)=>{
    const [activeLayers, setActiveLayers] = (0,react.useState)(new Map());
    const openLayer = (0,react.useCallback)((id, props)=>{
        setActiveLayers((layers)=>{
            const result = new Map(layers);
            result.set(id, props);
            return result;
        });
    }, []);
    const closeLayer = (0,react.useCallback)((id)=>{
        setActiveLayers((layers)=>{
            const result = new Map(layers);
            result.delete(id);
            return result;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithLayersContext.Provider, {
        value: {
            activeLayers,
            openLayer,
            closeLayer
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainModal/* default */.ZP, {
            ...props
        })
    });
};
ModalWithLayers.Layer = Layer_Layer;
ModalWithLayers.OpenButton = OpenButton_OpenButton;
const useModalWithLayers = ()=>(0,react.useContext)(ModalWithLayersContext);
/* harmony default export */ const ModalWithLayers_ModalWithLayers = (ModalWithLayers);


/***/ }),

/***/ 10962:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ NoData_NoData)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/feedback/NoData/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Nothing found"
    }
});

;// CONCATENATED MODULE: ./src/components/feedback/NoData/NoData.tsx





// TODO discuss with designers and add "No data" UI element - added on 1/18/21 by pavelivanov
const NoData = (param)=>{
    let { className, title } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "text-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "other/no-items"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-24",
                message: title || messages.title,
                style: "p2",
                html: true
            })
        ]
    });
};
/* harmony default export */ const NoData_NoData = (NoData);


/***/ }),

/***/ 36002:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78565);




const Note = (param)=>{
    let { className, message, "data-testid": dataTestId } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, "border-solid-gray-30 rounded bg-white px-16 py-20"),
        message: message,
        style: "p3",
        html: true,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Note);


/***/ }),

/***/ 95521:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Notification_Notification)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/inputs/CloseIconButton/CloseIconButton.tsx + 2 modules
var CloseIconButton = __webpack_require__(80899);
;// CONCATENATED MODULE: ./src/components/feedback/Notification/Notification.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Notification_module = ({"notification":"okX4W_","closed":"d3LEmb","notificationWithAnimation":"eAQb_N","openNotification":"BrskJb","closeButton":"_b_SGU"});
;// CONCATENATED MODULE: ./src/components/feedback/Notification/Notification.tsx





const Notification = (props)=>{
    const { children, className, closeNotification, timeout = 8000, withAnimation = true, onClick, onClose } = props;
    const nodeRef = (0,react.useRef)();
    const handleClose = (0,react.useCallback)(()=>{
        if (typeof closeNotification === "function" && nodeRef.current) {
            nodeRef.current.style.marginTop = `${-1 * nodeRef.current.clientHeight}px`;
            nodeRef.current.classList.add(Notification_module.closed);
            setTimeout(closeNotification, 300);
            if (typeof onClose === "function") {
                onClose();
            }
        }
    }, [
        closeNotification,
        onClose
    ]);
    (0,react.useEffect)(()=>{
        if (!timeout) {
            return;
        }
        const timer = setTimeout(handleClose, timeout);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        handleClose,
        timeout
    ]);
    const handleClick = (0,react.useCallback)((event)=>{
        event.stopPropagation();
        if (typeof onClick === "function") {
            onClick();
        }
        handleClose();
    }, [
        handleClose,
        onClick
    ]);
    const handleCloseIconClick = (0,react.useCallback)((event)=>{
        event.stopPropagation();
        handleClose();
    }, [
        handleClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: nodeRef,
        className: (0,clsx/* default */.Z)(className, Notification_module.notification, withAnimation && Notification_module.notificationWithAnimation),
        role: "alert",
        "data-testid": "notification",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconButton/* default */.Z, {
                className: Notification_module.closeButton,
                onClick: handleCloseIconClick
            }),
            children
        ]
    });
};
/* harmony default export */ const Notification_Notification = (Notification);


/***/ }),

/***/ 1987:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  tC: () => (/* binding */ ModalContext),
  LO: () => (/* binding */ bgColorToClassName),
  ZP: () => (/* binding */ PlainModal_PlainModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(63730);
// EXTERNAL MODULE: ./local_modules/trap-focus/TrapFocus.ts
var TrapFocus = __webpack_require__(66149);
// EXTERNAL MODULE: ./local_modules/router/shared/hooks.ts
var hooks = __webpack_require__(91746);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/helpers/twcx.ts
var twcx = __webpack_require__(19460);
// EXTERNAL MODULE: ./src/hooks/useUniqueId.ts
var useUniqueId = __webpack_require__(91327);
// EXTERNAL MODULE: ./src/hooks/useFreezeBodyScroll.ts
var useFreezeBodyScroll = __webpack_require__(19058);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(83298);
// EXTERNAL MODULE: ./src/components/layout/Overlay/Overlay.tsx + 1 modules
var Overlay = __webpack_require__(30389);
// EXTERNAL MODULE: ./src/components/inputs/CloseIconButton/CloseIconButton.tsx + 2 modules
var CloseIconButton = __webpack_require__(80899);
;// CONCATENATED MODULE: ./src/components/feedback/PlainModal/PlainModal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const PlainModal_module = ({"container":"SJY32f","openModal":"ZBRr8K","defaultContainer":"LpMUtj","rightSidebarContainer":"icE_sY","leftSidebarContainer":"AYdWT0","bottomContainer":"RZdvtg","plainModal":"cXF__J","sidebar":"A5qqwe","underHeader":"opVNko","bottomModal":"FZ3ZCn","fullscreen":"nQAMhE","overlay":"LDAm7E","topFullscreenContainer":"z4PKNS"});
;// CONCATENATED MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx











const ModalContext = /*#__PURE__*/ (0,react.createContext)(null);
const bgColorToClassName = {
    "white": "bg-white",
    "gray-10": "bg-gray-10",
    "dark-beige": "bg-dark-beige",
    "black-100": "bg-black-100"
};
const openedModalTypes = {
    underMobileHeader: 0,
    sideBarRight: 0
};
const PlainModal = (props)=>{
    const { children, className, containerClassName: containerClassNameProps, overlayClassName, underMobileHeader = false, overlayClosable = true, withCloseButton = true, shouldCloseOnPathnameChange = true, closeButtonIcon, closeButtonClassName, closeModal, bgColor = "gray-10", type = "default", "data-testid": dataTestId } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const pathname = (0,hooks/* usePathname */.jD)();
    const initPathname = (0,react.useRef)(pathname);
    const uniqueId = (0,useUniqueId/* default */.Z)();
    const titleId = `title_${uniqueId}`;
    const textId = `text_${uniqueId}`;
    const trapFocusId = `trapfocus_${uniqueId}`;
    const modalBodyRef = (0,react.useRef)(null);
    (0,useFreezeBodyScroll/* default */.Z)();
    const handleOverlayClick = (0,react.useCallback)(()=>{
        if (overlayClosable) {
            closeModal(true);
        }
    }, [
        overlayClosable,
        closeModal
    ]);
    const handleCloseButtonClick = (0,react.useCallback)(()=>{
        closeModal(true);
    }, [
        closeModal
    ]);
    const handleModalClick = (0,react.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    (0,react.useEffect)(()=>{
        const trapFocusElement = modalBodyRef.current;
        // could be "null" if modal opened in iframe
        if (trapFocusElement) {
            const trapFocus = new TrapFocus/* default */.Z(modalBodyRef.current, {
                withInitialFocus: false
            });
            trapFocusElement.focus();
            trapFocus.mount();
            return ()=>{
                trapFocus.unmount();
            };
        }
    }, []);
    // ATTN it's required only for some modals, otherwise overlay click closes all modals in a single click
    const useDocumentOverlayClick = isMobile && underMobileHeader;
    (0,react.useEffect)(()=>{
        if (!useDocumentOverlayClick) {
            return;
        }
        // Delay until after the current call stack is empty,
        // in case this effect is being run while an event is currently bubbling.
        // In that case, we don't want to listen to the pre-existing event.
        const timeout = setTimeout(()=>{
            document.addEventListener("click", handleOverlayClick);
        });
        return ()=>{
            clearTimeout(timeout);
            document.removeEventListener("click", handleOverlayClick);
        };
    }, [
        handleOverlayClick,
        useDocumentOverlayClick
    ]);
    (0,react.useEffect)(()=>{
        if (shouldCloseOnPathnameChange && pathname !== initPathname.current) {
            closeModal(true) // // TODO should we call "onClose" in case of route change? - added on 07.12.2021 by sonatskiy
            ;
        }
    }, [
        pathname,
        shouldCloseOnPathnameChange,
        closeModal
    ]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(()=>{
        if (!underMobileHeader || !isMobile) {
            return;
        }
        openedModalTypes.underMobileHeader++;
        const className = "fixed-header";
        document.body.classList.add(className);
        return ()=>{
            openedModalTypes.underMobileHeader--;
            if (!openedModalTypes.underMobileHeader) {
                document.body.classList.remove(className);
            }
        };
    }, [
        isMobile,
        underMobileHeader
    ]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(()=>{
        if (type !== "sidebar-right") {
            return;
        }
        openedModalTypes.sideBarRight++;
        const className = "sidebar-right-open";
        document.body.classList.add(className);
        return ()=>{
            openedModalTypes.sideBarRight--;
            if (!openedModalTypes.sideBarRight) {
                document.body.classList.remove(className);
            }
        };
    }, [
        type
    ]);
    // TODO refactor to tailwind completely to support overriding - added on 2023-12-22 by maddoger
    const containerClassName = (0,twcx/* twcx */.L)(PlainModal_module.container, {
        [PlainModal_module.defaultContainer]: type === "default",
        [PlainModal_module.leftSidebarContainer]: type === "sidebar-left",
        [PlainModal_module.rightSidebarContainer]: type === "sidebar-right",
        [PlainModal_module.topFullscreenContainer]: type === "fullscreen-top",
        [PlainModal_module.bottomContainer]: type === "bottom"
    }, containerClassNameProps);
    // Think
    const modalBodyClassName = (0,twcx/* twcx */.L)("relative flex flex-col", bgColorToClassName[bgColor], {
        [PlainModal_module.plainModal]: type === "default",
        [PlainModal_module.sidebar]: type === "sidebar-right" || type === "sidebar-left",
        [PlainModal_module.fullscreen]: type === "fullscreen-top",
        [PlainModal_module.bottomModal]: type === "bottom"
    }, className);
    const finalOverlayClassName = (0,twcx/* twcx */.L)("z-overlay", PlainModal_module.overlay, isMobile && underMobileHeader && PlainModal_module.underHeader, overlayClassName);
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContext.Provider, {
        value: {
            titleId,
            textId
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
            className: finalOverlayClassName,
            onClick: useDocumentOverlayClick ? null : handleOverlayClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClassName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: trapFocusId,
                    className: modalBodyClassName,
                    tabIndex: 0,
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": titleId,
                    "aria-describedby": textId,
                    "data-testid": dataTestId,
                    onClick: handleModalClick,
                    children: [
                        withCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconButton/* default */.Z, {
                            className: (0,twcx/* twcx */.L)(isMobile ? "right-16 top-16" : "right-32 top-32", closeButtonClassName),
                            icon: closeButtonIcon,
                            onClick: handleCloseButtonClick
                        }),
                        children
                    ]
                })
            })
        })
    }), document.getElementById("modals"));
};
/* harmony default export */ const PlainModal_PlainModal = (PlainModal);


/***/ }),

/***/ 14931:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Tooltip_Tooltip)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(63730);
// EXTERNAL MODULE: ./src/hooks/useUniqueId.ts
var useUniqueId = __webpack_require__(91327);
// EXTERNAL MODULE: ./src/hooks/useSSR.ts
var useSSR = __webpack_require__(16784);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(53297);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/helpers/getters/getElementPosition.ts
var getElementPosition = __webpack_require__(13836);
// EXTERNAL MODULE: ./src/helpers/devicePx.ts
var devicePx = __webpack_require__(21068);
;// CONCATENATED MODULE: ./src/components/feedback/Tooltip/util/createTooltip.ts


const setMobilePosition = (param)=>{
    let { trigger, tooltip, side } = param;
    const horizontalMobilePadding = (0,devicePx/* devicePx */.j)(40);
    const verticalMobilePadding = (0,devicePx/* devicePx */.j)(16);
    const viewportWidth = document.documentElement.clientWidth;
    const triggerPosition = (0,getElementPosition/* default */.Z)(trigger);
    const triggerBounds = trigger.getBoundingClientRect();
    let tooltipBounds = tooltip.getBoundingClientRect();
    let top;
    let left;
    let right;
    // if distance between viewport's right side and trigger is less than tooltip width
    // then the tooltip should be placed to the left of the trigger
    if (triggerBounds.right + tooltipBounds.width > viewportWidth || (side === null || side === void 0 ? void 0 : side.includes("left"))) {
        left = triggerPosition.left + triggerBounds.width - tooltipBounds.width;
        // if tooltip is off-screened
        if (left < 0) {
            if (triggerPosition.left < horizontalMobilePadding) {
                left = triggerPosition.left;
            } else {
                left = horizontalMobilePadding;
            }
        }
        // if tooltip doesn't fit the space between left and right sides of the viewport
        // by design the left and right padding size for full width tooltips is horizontalMobilePaddingpx
        if (tooltipBounds.width + left > viewportWidth - horizontalMobilePadding) {
            if (viewportWidth - triggerPosition.left - triggerBounds.width < horizontalMobilePadding) {
                right = viewportWidth - triggerPosition.left - triggerBounds.width;
            } else {
                right = horizontalMobilePadding;
            }
        }
    } else {
        left = triggerPosition.left;
    }
    tooltip.style.left = `${left}px`;
    tooltip.style.right = right ? `${right}px` : "auto";
    tooltipBounds = tooltip.getBoundingClientRect();
    // ATTN top should be calculated after "left" and "right" because height of the tooltip can change (text wrapping)
    // if distance between viewport's top side and trigger is less than tooltip height
    // then the tooltip should be placed to the bottom of the trigger
    if (triggerBounds.top - tooltipBounds.height < verticalMobilePadding || (side === null || side === void 0 ? void 0 : side.includes("bottom"))) {
        top = triggerPosition.top + triggerBounds.height;
    } else {
        top = triggerPosition.top - tooltipBounds.height;
    }
    tooltip.style.top = `${top}px`;
};
const setDesktopPosition = (param)=>{
    let { trigger, tooltip, side } = param;
    const verticalPadding = 16;
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;
    const triggerPosition = (0,getElementPosition/* default */.Z)(trigger);
    const triggerBounds = trigger.getBoundingClientRect();
    const tooltipBounds = tooltip.getBoundingClientRect();
    let top;
    let left;
    // if distance between viewport's bottom side and trigger is less than tooltip height
    // then the tooltip should be placed to the top of the trigger
    if (viewportHeight - triggerBounds.bottom - tooltipBounds.height < verticalPadding && !(side === null || side === void 0 ? void 0 : side.includes("bottom"))) {
        top = triggerPosition.top - tooltipBounds.height;
    } else {
        top = triggerPosition.top + triggerBounds.height;
    }
    // if distance between viewport's right side and trigger is less than tooltip width
    // then the tooltip should be placed to the left of the trigger
    if (triggerBounds.right + tooltipBounds.width > viewportWidth || (side === null || side === void 0 ? void 0 : side.includes("left"))) {
        left = triggerPosition.left + triggerBounds.width - tooltipBounds.width;
        // if tooltip is off-screened
        if (left < 0) {
            left = verticalPadding;
        }
    } else {
        left = triggerPosition.left;
    }
    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
};
const setTooltipPosition = (param)=>{
    let { trigger, tooltip, isMobile, side } = param;
    if (isMobile) {
        setMobilePosition({
            trigger,
            tooltip,
            side
        });
    } else {
        setDesktopPosition({
            trigger,
            tooltip,
            side
        });
    }
};
const createTooltip = (param)=>{
    let { trigger, tooltip, styles, isMobile, onShow, onHide, visible, side, ignoreBlur, ignoreScroll, ignoreClick = true, ignoreTouchStart } = param;
    const show = ()=>{
        // remove style attribute from previous execution
        tooltip.removeAttribute("style");
        // show tooltip to allow the script to calculate tooltip width / height
        tooltip.classList.add(styles.visible);
        setTooltipPosition({
            tooltip,
            trigger,
            isMobile,
            side
        });
        if (!ignoreTouchStart) {
            document.addEventListener("touchstart", hide, {
                passive: true,
                capture: true
            });
        }
        document.addEventListener("keydown", hideOnEscapePress);
        if (!ignoreClick) {
            document.addEventListener("click", hide);
        }
        if (!ignoreBlur) {
            window.addEventListener("blur", hide);
        }
        if (!ignoreScroll) {
            window.addEventListener("scroll", hide, {
                passive: true
            });
        }
        onShow === null || onShow === void 0 ? void 0 : onShow();
    };
    const hide = ()=>{
        tooltip.classList.remove(styles.visible);
        document.removeEventListener("touchstart", hide, {
            capture: true
        });
        document.removeEventListener("keydown", hideOnEscapePress);
        document.removeEventListener("click", hide);
        window.removeEventListener("blur", hide);
        window.removeEventListener("scroll", hide);
        onHide === null || onHide === void 0 ? void 0 : onHide();
    };
    const hideOnEscapePress = (event)=>{
        if (event.key === "Escape") {
            hide();
        }
    };
    trigger.addEventListener("focus", show);
    trigger.addEventListener("touchstart", show, {
        passive: true
    });
    trigger.addEventListener("mouseenter", show);
    if (!ignoreBlur) {
        trigger.addEventListener("blur", hide);
        trigger.addEventListener("mouseleave", hide);
    }
    if (visible) {
        show();
    }
    // unmount callback for useEffect
    return ()=>{
        trigger.removeEventListener("focus", show);
        trigger.removeEventListener("touchstart", show);
        trigger.removeEventListener("mouseenter", show);
        trigger.removeEventListener("mouseleave", hide);
        trigger.removeEventListener("blur", hide);
        document.removeEventListener("touchstart", hide, {
            capture: true
        });
        document.removeEventListener("keydown", hideOnEscapePress);
        document.removeEventListener("click", hide);
        window.removeEventListener("blur", hide);
        window.removeEventListener("scroll", hide);
    };
};
/* harmony default export */ const util_createTooltip = (createTooltip);

;// CONCATENATED MODULE: ./src/components/feedback/Tooltip/Tooltip.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Tooltip_module = ({"tooltip":"Usc0r_","visible":"zqU_6o"});
;// CONCATENATED MODULE: ./src/components/feedback/Tooltip/Tooltip.tsx










const Tooltip = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { id, title, text, style, className, side } = props;
    const { isDesktop } = (0,useDevice/* default */.Z)();
    const bgStyle = {
        "bg-white rounded": style === "white",
        "bg-light-beige": style === "light-beige",
        "bg-black text-white": style === "dark"
    };
    const rootClassName = (0,clsx/* default */.Z)(Tooltip_module.tooltip, "absolute p-16 shadow", bgStyle, (side === null || side === void 0 ? void 0 : side.includes("bottom")) ? "mt-32" : undefined, (side === null || side === void 0 ? void 0 : side.includes("left")) && isDesktop ? "ml-16" : undefined, className);
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        id: id,
        className: rootClassName,
        role: "tooltip",
        children: [
            (side === null || side === void 0 ? void 0 : side.includes("bottom")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("absolute top-0 -z-1 size-[34rem] origin-top rotate-45 rounded-2", bgStyle, side === "bottom-left" ? "right-0" : "left-1/2")
            }),
            Boolean(title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-8",
                message: title,
                style: "sh5",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: text,
                style: "p4",
                html: true
            })
        ]
    }), document.getElementById("tooltips"));
});
const TooltipWrapper = (props)=>{
    const { children, title, text, style, onShow, onHide, visible, className, side, ignoreBlur, ignoreScroll, ignoreClick, ignoreTouchStart } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const id = (0,useUniqueId/* default */.Z)("tooltip");
    const triggerRef = (0,react.useRef)();
    const tooltipRef = (0,react.useRef)();
    const onShowRef = (0,react.useRef)(null);
    onShowRef.current = onShow;
    const onHideRef = (0,react.useRef)(null);
    onHideRef.current = onHide;
    const isSSR = (0,useSSR/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (isSSR) {
            return;
        }
        if (!triggerRef.current) {
            logger/* default */.Z.error({
                children,
                text
            }, "triggerRef for Tooltip is undefined");
            return;
        }
        return util_createTooltip({
            trigger: triggerRef.current,
            tooltip: tooltipRef.current,
            styles: Tooltip_module,
            isMobile,
            onShow: onShowRef.current,
            onHide: onHideRef.current,
            visible,
            side,
            ignoreBlur,
            ignoreScroll,
            ignoreClick,
            ignoreTouchStart
        });
    }, [
        children,
        text,
        isMobile,
        isSSR,
        visible,
        side,
        ignoreBlur,
        ignoreScroll,
        ignoreTouchStart,
        ignoreClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSSR && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                ref: tooltipRef,
                id: id,
                title: title,
                text: text,
                style: style,
                className: className,
                side: side
            }),
            /*#__PURE__*/ react.cloneElement(children, {
                ref: triggerRef,
                "aria-describedby": id
            })
        ]
    });
};
/* harmony default export */ const Tooltip_Tooltip = (/*#__PURE__*/react.memo(TooltipWrapper));


/***/ })

}]);